import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from './auth.service';
import { AuthGuard } from './auth.guard';
import { UserService } from './user.service';
import {AuthRoutingModule} from './auth-routing.module';
import {LoginComponent} from './login/login.component';
import {FormsModule} from '@angular/forms';
import {AuthValidateComponent} from './auth-validate/auth-validate.component';
import {AdminGuard} from './admin.guard';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';
import { LoginAsComponent } from './login-as/login-as.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AuthRoutingModule
  ],
  declarations: [LoginComponent, AuthValidateComponent, NotAuthorizedComponent, LoginAsComponent],
  providers: [AuthService, AuthGuard, UserService, AdminGuard]
})
export class AuthModule { }



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts